import ModalWidget from './ModalWidget';

export default ModalWidget;
